import React, { useState, useEffect } from 'react';
import './Review.css';
import * as QUESTION from '../../../../constants/questions';
import { alphabet, getAge } from '../../../../static/utils';
import Stripe from '../../../elements/stripe';
import { updateReview } from '../../../../firebase/api/review';
import { convertDateToFirestoreTimestamp } from '../../../../firebase/api/firestoreUtils';
import { newTransaction } from '../../../../firebase/api/transaction';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { MIN_DONATE } from '../../../../configs';
import { payByReview } from '../../../../firebase/api/stripe';

export const Review = ({ review, postType, user }) => {
    const [total, setTotal] = useState(review.minDonation);
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);

    async function payForReview(token) {
        toggle();
        payByReview(review.uid, token).then(result => {
            result && result.data && onPayPalHandler(result.data, true);
        });
    }

    function onPayPalHandler(body, isSuccessful) {
        if (isSuccessful) {
            const { publisher, ...newReview } = review;
            newReview.donation = +newReview.donation + 1;
            updateReview(newReview);
        }
        const dto = {
            createdTimestamp: convertDateToFirestoreTimestamp(new Date()),
            donation: +1,
            isSuccessful: isSuccessful,
            postOwnerUid: review.postOwnerUid,
            reviewOwnerUid: review.publisherUid,
            reviewUid: review.uid,
            message: body,
        };
        newTransaction(dto);
    }

    return (
        <div className={'postReview'}>
            <div className="post-review-question">
                {postType === QUESTION.YES_NO && (
                    <div className="typeYESNO">
                        <p>{review.questions[0].title}</p>
                    </div>
                )}
                {/*<p className={'reviewDonation'}>&#163;{review.minDonation}</p>*/}
            </div>
            <div className="post-review-body">
                <div className={'reviewText'}>
                    <p>{review.text}</p>
                    {postType === QUESTION.MULTIPLE && (
                        <div className="multiple-question">
                            {review.questions &&
                                review.questions.map((question, index) => (
                                    <div key={index} className={'multiple-question-item'}>
                                        <div className={'letter'}>{alphabet[question.order]}</div>
                                        <div className={'title'}>{question.title}</div>
                                    </div>
                                ))}
                        </div>
                    )}
                </div>
                {user && (
                    <div>
                        {user.isPremium ? (
                            <p className="reviewUser">
                                {user.firstName} {user.lastName} | {user.age} | {user.position} |{' '}
                                {user.websiteLink}
                            </p>
                        ) : (
                            <p className="reviewUser">
                                {user.position} | {user.age} | Contact details become visible with
                                pro membership.
                            </p>
                        )}
                    </div>
                )}
            </div>

            <div className="payPalForm">
                <Button className="btn primary" onClick={toggle}>
                    PAY
                </Button>
                <Modal isOpen={modal} className="inviteFriendsModal" toggle={toggle}>
                    <ModalHeader toggle={toggle}>Pay</ModalHeader>
                    <ModalBody>
                        <Stripe payForReview={payForReview} total={MIN_DONATE} />
                    </ModalBody>
                </Modal>
            </div>
        </div>
    );
};
